/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `dlg` - dl/g
 * `` - (empty)
 * `kgm2` - kg/m2
 * `kilogram` - Kilogram
 * `percent` - %
 * `%wm` - % w.m
 * `ppm` - ppm
 * `text` - Text
 * `mg/Kg w.m.` - mg/Kg w.m.
 * `g/10min` - g/10min
 * `kg/m3` - kg/m3
 * `g/cm3` - g/cm3
 */
export type UnitOfMeasure = (typeof UnitOfMeasure)[keyof typeof UnitOfMeasure];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UnitOfMeasure = {
  dlg: 'dlg',
  kgm2: 'kgm2',
  kilogram: 'kilogram',
  percent: 'percent',
  '%wm': '%wm',
  ppm: 'ppm',
  text: 'text',
  'mg/Kg_wm': 'mg/Kg w.m.',
  'g/10min': 'g/10min',
  'kg/m3': 'kg/m3',
  'g/cm3': 'g/cm3',
} as const;
